import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUberPickupinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 5,
				y: 5,
				width: 54,
				height: 54,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("path", { d: "M26 32H14" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 32,
				cy: 32,
				r: 18
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 26,
				y: 25,
				width: 13,
				height: 14,
				rx: 2
			})
		]
	})
});
export default SvgUberPickupinline;
